import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { deleteMenuThumbnails, menuThumbnailList } from "./api";

// Menu thumbnails come from the API (admin/menu-thumbnail/*).

export const MEDIA_TYPE = { video: 1, podcast: 2, shorts: 4, news: 5, program: 6 }; // config('radiomango.menu_thumbnail_type')

export const FILTERS = [
  { id: "all", label: "All", type: null },
  { id: "podcast", label: "Podcast", type: MEDIA_TYPE.podcast },
  { id: "video", label: "Video", type: MEDIA_TYPE.video },
  { id: "shorts", label: "Shorts", type: MEDIA_TYPE.shorts },
  { id: "news", label: "News", type: MEDIA_TYPE.news },
  { id: "program", label: "Program", type: MEDIA_TYPE.program },
];

const PAGE_SIZE = 20;

/**
 * Loads the thumbnails for one type. `type` is null for all types.
 */
export const useThumbnailList = ({ type = null, search = "" } = {}) => {
  const [items, setItems] = useState([]);
  const [counts, setCounts] = useState({ podcast: 0, video: 0, shorts: 0, news: 0, program: 0 });
  const [isLoading, setIsLoading] = useState(true);

  const fetchList = useCallback(async () => {
    setIsLoading(true);
    const response = await menuThumbnailList({
      page: 1,
      length: PAGE_SIZE,
      ...(type ? { type } : {}),
      ...(search ? { search } : {}),
    });
    setIsLoading(false);

    const body = response?.data?.data?.original ?? response?.data?.original;
    if (response?.status === 200 && body) {
      setItems(body.data ?? []);
      setCounts(body.type_counts ?? { podcast: 0, video: 0, shorts: 0, news: 0, program: 0 });
    } else {
      setItems([]);
      toast.error(response?.data?.message ?? response?.message ?? "Unable to load thumbnails");
    }
  }, [type, search]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const removeThumbnails = async (ids) => {
    const response = await deleteMenuThumbnails(ids);
    if (response?.status === 200) {
      toast.success(response?.data?.message ?? "Thumbnail(s) deleted");
      fetchList();
      return true;
    }
    toast.error(response?.data?.message ?? response?.message ?? "Unable to delete");
    return false;
  };

  return { items, counts, isLoading, refetch: fetchList, removeThumbnails };
};
